import * as THREE from 'three';

class GeometryPool {
    constructor() {
        // Standard unit plane geometry that we'll scale via mesh transforms
        this.unitPlaneGeometry = new THREE.PlaneGeometry(1, 1);
        
        // Keep track of created geometries for cleanup
        this.geometries = new Set();
        this.geometries.add(this.unitPlaneGeometry);
    }

    // Get the standard unit plane geometry
    getUnitPlane() {
        return this.unitPlaneGeometry;
    }

    // Create a plane mesh with specific dimensions using scaling
    createPlaneMesh(width, height, material, position = { x: 0, y: 0, z: 0 }) {
        const mesh = new THREE.Mesh(this.unitPlaneGeometry, material);
        
        // Scale the mesh to the desired dimensions
        mesh.scale.set(width, height, 1);
        
        // Set position
        mesh.position.set(position.x, position.y, position.z);
        
        return mesh;
    }

    // Create geometry for special cases where scaling won't work
    createCustomGeometry(width, height) {
        const geometry = new THREE.PlaneGeometry(width, height);
        this.geometries.add(geometry);
        return geometry;
    }

    // Dispose of all geometries
    dispose() {
        this.geometries.forEach(geometry => {
            if (geometry.dispose) {
                geometry.dispose();
            }
        });
        this.geometries.clear();
    }
}

// Export singleton instance
export const geometryPool = new GeometryPool(); 